import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap';
import Select from 'react-select';

import { required, number, positiveNumber, email } from '../../../forms';
import PhoneInput, { formatPhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

const Error = ({ name }) => (
  <Field
    name={name}
    subscription={{ touched: true, error: true }}
    render={({ meta: { touched, error } }) =>
      touched && error ? <span className="alert-danger">{error}</span> : null
    }
  />
);
export const customPhoneInput = ({ input, label, type, country, meta: { touched, error, warning } }) => (
  <InputGroup>
  {label && <ControlLabel>{label}</ControlLabel>}
  <PhoneInput {...input} type={type} country={country} />
  { input.value ? (isValidPhoneNumber(input.value) ? undefined : <p className="alert alert-danger">Invalid phone number</p>) : '' }
  </InputGroup>
);

export const renderTextField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
  </InputGroup>
);

const HotelContactsForm = ({ onSubmit, initialValues, options, handleClose }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={(values) => {
      const errors = {};
      if (!values.name) {
        errors.FORM_ERROR = 'Please provide the contact name.';
      }else if(!values.email){
           errors.FORM_ERROR = 'Please provide the email address.';
      }else if(!values.contact){
        errors.FORM_ERROR = 'Please provide the contact Number.';
      }else if (!isValidPhoneNumber(values.contact)) {
        errors.FORM_ERROR = 'Please enter valid contact Number.';
      }
      return errors;
    }}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => (
      <form onSubmit={handleSubmit} >
        <h1 className="hotel-detail-subhead">Hotel Contacts</h1>
        <FormGroup>
          <Field
            name="name"
            component={renderTextField}
            label="Names"
            placeholder="John Smith"
            validate={required}
          />
          <Field
            name="email"
            component={renderTextField}
            label="Email"
            placeholder="john@example.com"
            validate={required,email}
          />
           <Error name="email" />

           <Field
                name="contact"
                type="text"
                country="US"
                component={customPhoneInput}
                label="Contact (Please select a Country and provide Phone Number)"
                placeholder="Enter phone number"
                 />
           {/* <Field
            name="contact"
            component={renderTextField}
            label="Contact"
            placeholder=""
            validate={required,number}
          /> */}

        </FormGroup>
        {errors !== undefined && errors.FORM_ERROR && (
          <p className="alert alert-danger">{errors.FORM_ERROR}</p>
        )}
        {errors !== undefined && errors.note && (
          <p className="alert alert-danger">{errors.note}</p>
        )}
        <FormGroup>
          <ButtonToolbar>
            <Button
              disabled={pristine || submitting}
              bsStyle="success"
              type="submit"
            >
              Save
            </Button>
            <Button
              disabled={submitting}
              bsStyle="success"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </FormGroup>
      </form>
    )}
  />
  );

export default HotelContactsForm;



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelContactsForm.js